module.exports = __webpack_public_path__ + "static/media/sold_out_lg.cce6d847.svg";